import { useContext, useEffect } from "react";
import { useUserMe } from "@/features/login/hooks/useUserMe";
import { userDataContext } from "@/hooks/useUserData";
import { AcquireBookListPresenter } from "./presenter";

export const AcquireBookListContainer: React.FC = () => {
  const { data: user } = useContext(userDataContext);
  const { userMe } = useUserMe();

  useEffect(() => {
    if (!user.id) userMe();
    // 一覧を開いた時だけ復元し、再描画や一覧切替では再取得しない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AcquireBookListPresenter />;
};
